import { AppStoreState } from './app-store';
import { initialState as appInitialState } from './app-store/state';
import { ContactFormStoreState } from './contact-form-store';
import { FederationDetailStoreState } from './federation-detail-store';
import { FederationsStoreState } from './federations-store';
import { NewAccountStoreState } from './new-account-store';
import { SubsidiariesStoreState } from './subsidiaries-store';
import { SubsidiaryDetailStoreState } from './subsidiary-detail-store';

export interface RootState {
	app: AppStoreState.IAppState;
	subsidiaries: SubsidiariesStoreState.ISubsidiariesState;
	newAccount: NewAccountStoreState.INewAccountState;
	contactForm: ContactFormStoreState.IContactFormState;
	subsidiaryDetail: SubsidiaryDetailStoreState.ISubsidiaryDetailState;
	federations: FederationsStoreState.IFederationsState;
	federationDetail: FederationDetailStoreState.IFederationDetailState;
}

export function getStateFromPreviousSession(): Partial<RootState> {
	return {
		app: {
			...appInitialState,

			// only put here anonymous store data that
			// should be kept between sessions
			// config: state.app.config,
		},
	};
}
